module.exports = __webpack_public_path__ + "static/media/IMG_7263-min.19e06b28.jpg";